import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client'
import { handleRequestErrors, link } from './apollo-middlewares'

const cache = new InMemoryCache({})

/**
 * Error policy.
 *
 * The api-gateway forwards every subgraph error as an `errors[]` entry
 * (DEV-158). A query can therefore come back with `data` and `errors` at the
 * same time when a nullable nested field fails, e.g. `user.level`, which the
 * rewards subgraph resolves inside game, chat, leaderboard and `me` queries.
 *
 * - `useQuery` / `useLazyQuery` (`watchQuery`) use `errorPolicy: 'all'`: the
 *   fields that resolved are kept and rendered, the failed ones are `null`, and
 *   `error` is still set. Render from `data` and treat `error` as a full
 *   failure only when `data` is missing. Root fields are non-null, so a failed
 *   root field still nulls the whole `data`.
 * - `client.query` and mutations keep the default `errorPolicy: 'none'`:
 *   callers await them and rely on the rejection.
 * - `onError` callbacks also fire for partial errors. A callback that notifies
 *   the user must skip errors whose path is below a root field (see
 *   `isPartialFailure`).
 * - `handleRequestErrors` notifies only for an error whose message is
 *   `INTERNAL_SERVER_ERROR` and logs the rest, so the newly forwarded errors
 *   (the gateway sends the real message, or "Internal server error" in
 *   production) are not shown to the user by the link.
 */
export const apolloClient = new ApolloClient({
  link: ApolloLink.from([handleRequestErrors, link]),
  connectToDevTools: true,
  cache,
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all'
    }
  }
})
